
export default {
  props: {
    your: {
      type: [String, Number],
      required: false,
      default: 0,
    },

    msrp: {
      type: [String, Number],
      required: false,
      default: 0,
    },
  },
};
